import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import missing_image from "./../../i/missing_image.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";

import {
  sortNumeric,
  selectFormat,
  getMetricForColumn,
  Error,
} from "components/Utils/Utils.js";

export const CellTextImage = (cell, row, rowIndex, opts) => {
  // Image
  let IMAGE = { backgroundImage: `url(${missing_image})` };
  if (row.image_url == null) {
    IMAGE = { backgroundImage: `url(${missing_image})` };
  } else {
    IMAGE = { backgroundImage: `url(${row.image_url.replace(/'/g, "%27")})` };
  }

  // Title
  let TITLE = "";
  if (row.title !== null && row.title !== "") {
    TITLE = <h1 className="content-table__title">{row.title}</h1>;
  } else {
    TITLE = "";
  }

  return (
    <article className="content-table">
      <figure className="content-table__figure">
        <div
          data-tooltip-id="tooltip-video"
          data-tooltip-html='<iframe width="380" height="214" src="https://www.youtube.com/embed/dQw4w9WgXcQ" frameBorder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title={"video"}></iframe>'
          data-event="click focus"
        >
          <div className="content-table__img" style={IMAGE} />
        </div>
      </figure>

      <section className="content-table__detail">{TITLE}</section>
    </article>
  );
};

class HearstPublishers extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "id",
        text: "Creative",
        style: { width: "100px", minWidth: "100px" },
        sort: true,
        formatter: CellTextImage,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "video_views",
        text: "Video Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_completion",
        text: "Video Completion",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_completion_rate",
        text: "Video Completion Rate",
        style: { width: "100px", minWidth: "100px" },
        formatExtraData: { type: "percentage" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "ctv_impressions",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <>
        <ToolkitProvider
          keyField="id"
          data={data}
          columns={selected_columns}
          striped={false}
          hover={false}
          bordered={false}
          exportCSV={{ fileName: filename + ".csv" }}
        >
          {(props) => (
            <BootstrapTable
              {...props.baseProps}
              {...props.csvProps}
              defaultSorted={defaultSorted}
              pagination={pagination}
              filter={filterFactory()}
              ref={(el) => (this.childRef = el)}
            />
          )}
        </ToolkitProvider>
        <ReactTooltip id="tooltip-video" className="title-tooltip-header" />
      </>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default HearstPublishers;
